export const claimDetailsAPITransformer = (data) => {
  let claimDetails = {
    ownerPrettyId: data.owner.pretty_id,
    ownerShortName: data.owner.short_name,
    requestId: data.request_id,
    state: data.state,
    imageUploadAllowedUntil: data.image_upload_allowed_until,
    dateOfLoss: data.date_of_loss,
    images: data.images,
    description: data.description,
    vin: data.vin,
    claimNumber: data.claim_number,
    motorcycle: `${data.motorcycle.year} ${data.motorcycle.make} ${data.motorcycle.model}`
  }

  return claimDetails
}
